var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10382 5.89027L5.52851 4.46557C6.3121 3.68199 7.58271 3.67038 8.3521 4.43978L9.08652 5.17419C9.89089 5.97856 10.0347 7.23364 9.43985 8.22019L8.71599 9.41967C8.47237 9.81717 8.58008 10.2753 8.85307 10.6395C10.6173 12.9935 11.3167 13.6929 13.3575 15.144C13.7285 15.4078 14.1799 15.5247 14.5774 15.2811L15.7769 14.5572C16.7634 13.9623 18.0185 14.1062 18.8228 14.9105L19.5573 15.6449C20.3267 16.4143 20.3151 17.6849 19.5315 18.4685L18.5 19.5L18.0928 19.8792C17.2308 20.7412 15.9438 21.007 14.8256 20.5585L14.2771 20.3376C9.66559 18.2763 5.74804 14.43 3.64545 9.70599L3.42459 9.15745C2.97601 8.03927 3.24188 6.75221 4.10382 5.89027Z",
    stroke: "#232C34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.456dfda04cd7fd47f54212b2b2bb81ca.svg";
export { ForwardRef as ReactComponent };